import { ActionBarContext, ModalService } from "@bb-vendure/admin-ui/core";
import { firstValueFrom, take } from "rxjs";
import { RequestRefundOrderDialogComponent } from "./request-refund-order-dialog/request-refund-order-dialog.component";
import { GetOrderDetailDocument } from "./generated-graphql/graphql";
import { map } from "lodash";
import { RefundOrderDialogComponent } from "./refund-order-dialog/refund-order-dialog.component";

export async function requestOrderDetail(context: ActionBarContext) {
  const orderId = context.route.snapshot.params.id;
  const modalService = context.injector.get(ModalService);
  // const { order } = await firstValueFrom(
  //   context.dataService.query(GetOrderDetailDocument, {
  //     id: orderId,
  //   }).single$
  // );
  const invalidStateArray = [
    "ArrangingPayment",
    "PaymentAuthorized",
    "Created",
    "Draft",
    "AddingItems",
    "Cancelled",
  ];

  context.entity$.subscribe((order) => {
    if (invalidStateArray.includes(order?.state!)) {
      context.notificationService.error(
        "Orders must from the 'PaymentSettled' status before a refund request can be submitted"
      );
      return;
    }
    if (order) {
      modalService
        .fromComponent(RefundOrderDialogComponent, {
          locals: {
            order: order as any,
          },
          size: "xl",
        })
        .pipe(take(1))
        .subscribe((res) => {
          if (res) {
            context.notificationService.success(
              "Created refund request succesfully"
            );
          }
        });
    }
  });
}
